import { RequestService } from '../../../../../common/services/RequestService';
import { GET_ORDER_BY_ID } from '../constants';
import { dataAdjustmentResponse } from './dataAdjustmentResponse';

export const getDocumentById = async (orderId, profileId) => {
  const response = await RequestService.get(
    GET_ORDER_BY_ID.replace('{order_id}', orderId).replace(
      '{profile_id}',
      profileId
    )
  );
  return {
    data: dataAdjustmentResponse(response.data),
  };
};
